import { render, staticRenderFns } from "./CreatePostcode.vue?vue&type=template&id=33ed17dc&"
import script from "./CreatePostcode.vue?vue&type=script&lang=js&"
export * from "./CreatePostcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports